import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Shield, Brain, Wallet } from 'lucide-react';
export function SolutionSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="bg-navy-800 py-24 text-cream" data-id="element-96">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-98">
          <span className="text-gold uppercase tracking-widest text-sm font-bold mb-2 block" data-id="element-99">
            Introducing
          </span>
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-white mb-6" data-id="element-100">
            The Sovereignty Method
          </h2>
          <p className="text-xl text-cream-warm/80 max-w-2xl mx-auto" data-id="element-101">
            A 30-day roadmap that doesn't seek to "change you," but to equip
            your life.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-102">
          <motion.div variants={itemVariants} className="bg-navy-900 p-8 rounded-xl border border-navy-700 hover:border-gold/50 transition-colors" data-id="element-103">
            <div className="w-14 h-14 bg-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-104">
              <Brain className="w-7 h-7 text-gold" data-id="element-105" />
            </div>
            <h3 className="text-xl font-serif font-bold text-white mb-3" data-id="element-106">
              Female Psychology
            </h3>
            <p className="text-cream-warm/70" data-id="element-107">
              Applied mental tools to eradicate impostor syndrome and anxiety
              about the future.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-navy-900 p-8 rounded-xl border border-navy-700 hover:border-gold/50 transition-colors" data-id="element-108">
            <div className="w-14 h-14 bg-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-109">
              <Shield className="w-7 h-7 text-gold" data-id="element-110" />
            </div>
            <h3 className="text-xl font-serif font-bold text-white mb-3" data-id="element-111">
              Security Logistics
            </h3>
            <p className="text-cream-warm/70" data-id="element-112">
              Practical protocols for your home, health, and environment that
              will give you unbreakable peace of mind.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-navy-900 p-8 rounded-xl border border-navy-700 hover:border-gold/50 transition-colors" data-id="element-113">
            <div className="w-14 h-14 bg-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-114">
              <Wallet className="w-7 h-7 text-gold" data-id="element-115" />
            </div>
            <h3 className="text-xl font-serif font-bold text-white mb-3" data-id="element-116">
              Autonomous Finances
            </h3>
            <p className="text-cream-warm/70" data-id="element-117">
              Financial strategies designed specifically for independent women
              looking to build wealth.
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-118">
          <p className="text-2xl sm:text-3xl font-serif text-gold italic mb-8" data-id="element-119">
            "It's not theory. It's Life Engineering for the Autonomous Woman."
          </p>
        </motion.div>
      </div>
    </section>;
}